import Vue from "vue";
import Toasted from "vue-toasted";

Vue.config.productionTip = false;
Vue.use(Toasted, { position: "top-center", fullWidth: true, fitToScreen: true, duration: 3000 });
